module.exports = __webpack_public_path__ + "components/MapControl/svg/Przechowalnia bagażu.svg?b7655d25";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Przechowalnia bagażu.svg
// module id = 1980
// module chunks = 0